import {ref} from 'vue';

export default function useForm(){
    let submitted = ref(false);
    let isLoading = ref(false);
    let formErrors = ref([]);

    const catchErrors = (errors) =>{
        formErrors.value = errors;
        submitted.value = false;
        isLoading.value = false;
    }
    const catchSuccess= () =>{
        isLoading.value = false;
    }
    const clearInput = (fieldName)=> {
        if (_.has(this.formErrors, fieldName)) {
            delete this.formErrors[fieldName];
        }
        submitted.value = !!Object.keys(this.formErrors).length;
    };

    const clearErrors = ()=>  {
        formErrors.value = _.cloneDeep([]);
        submitted.value = false;
    };


    const resetForm = (data) => {
        Object.keys(data).forEach(function (key) {
            data[key] = '';
        });
    };

    const validate = (val) => {
        if (val === '' || val === undefined || val === null) {
            return false
        }
        return true
    }

    return {isLoading, submitted, formErrors, catchErrors, catchSuccess, clearInput, clearErrors, resetForm, validate};
}
